<template>
  <div class="work__panel" ref="workPanel">
    <div class="work__panel__inner">
      <ClientOnly>
        <div
          v-if="!$mq.isMobile && data?.link?.url"
          class="work__panel__footer spv-120"
        >
          <a :href="data.link.url" :target="data.link.target">
            <AppLink class="fs-14" :underline="true">Visit Website</AppLink>
          </a>
        </div>
      </ClientOnly>

      <div class="work__panel__data">
        <div class="work__panel__row">
          <span class="fs-12 ff-mono" data-split>Name</span>
          <span class="fs-12" data-split> {{ data?.name }} </span>
        </div>
        <div class="work__panel__row">
          <span class="fs-12 ff-mono" data-split> Role </span>
          <span class="fs-12" data-split> {{ data?.role }} </span>
        </div>
        <div class="work__panel__row">
          <span class="fs-12 ff-mono" data-split> Agency </span>
          <span class="fs-12" data-split> {{ data?.agency }} </span>
        </div>
        <div
          class="work__panel__row"
          v-if="Object.keys(groupedProjects).length > 0"
        >
          <span class="fs-12 ff-mono" data-split> Recognitions </span>

          <ul class="fs-12 work__panel__row__list">
            <li
              class="work__panel__row__list__item"
              v-for="(awards, platform) in groupedProjects"
            >
              <span class="work__panel__row__platform" data-split>
                {{ platform }}
              </span>
              <span
                class="work__panel__row__award"
                v-for="el in awards"
                data-split
              >
                ( {{ el.label }} )
              </span>
            </li>
          </ul>
        </div>
        <div class="work__panel__row">
          <span class="fs-12 ff-mono" data-split> Year </span>
          <span class="fs-12" data-split> {{ data?.year }} </span>
        </div>
      </div>

      <ClientOnly>
        <div
          v-if="$mq.isMobile && data?.link?.url"
          class="work__panel__footer work__panel__footer--mobile"
        >
          <a :href="data.link.url" :target="data.link.target">
            <AppLink class="fs-16" :underline="true">Visit Website</AppLink>
          </a>
        </div>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup>
const { $gsap: gsap, $SplitText } = useNuxtApp();
const workPanel = ref(null);
const { registerSplitText } = useAnimationCleanup();

const props = defineProps({
  data: { type: Object, default: null },
});

onMounted(() => {
  if (workPanel.value) {
    const splitInstance = $SplitText.create(
      qsa('[data-split]', workPanel.value),
      {
        type: 'lines',
        mask: 'lines',
        autoSplit: true,
        linesClass: 'line',
        wordsClass: 'word',
        smartWrap: true,
        onSplit: self => {
          self?.lines?.forEach((myLine, i) => {
            gsap.set(myLine, { '--index': i });
          });
        },
      }
    );

    // Register for cleanup
    registerSplitText(splitInstance);
  }
});

const groupedProjects = computed(() => {
  return props?.data?.recognitions?.reduce((acc, item) => {
    if (!acc[item.platform]) {
      acc[item.platform] = [];
    }
    acc[item.platform].push(item);
    return acc;
  }, {});
});
</script>

<style lang="scss" scoped>
.work__panel {
  // background: var(--c-bg-alt);
  color: var(--c-text);
  width: var(--width);
  padding: var(--offset);
  padding-top: var(--top-offset);
  margin-bottom: fluidMap($spacing, 60);

  @include mq(desktop) {
    width: var(--col-2);
    position: fixed;
    bottom: 0;
    right: var(--offset);
    padding: 0;
    padding-bottom: calc(var(--gutter) + var(--offset));
    margin-bottom: fluidMap($spacing, 20);
  }

  &:deep(.line) {
    transform: translateY(100%);
    transition: transform 1s ease(outExpo) calc((var(--index) * 0.05s) + 0.05s);
  }

  &.is-animated:deep(.line) {
    transform: translateY(0%);
  }
}

.work__panel__inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.work__panel__data {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.work__panel__title {
  width: var(--col-1);
  display: flex;
  // margin-left: col(1);
}

.work__panel__row__platform,
.work__panel__row__award {
  margin-bottom: 0.6rem;
}

.work__panel__row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--gutter);
  text-transform: uppercase;
  width: var(--width);

  @include mq(desktop) {
    width: var(--col-2);
  }
}

.work__panel__row__platform {
  padding-left: 0ch;
}

.work__panel__row__award {
  padding-left: 4ch;

  @include mqBetween(desktop, desktop-m) {
    padding-left: 0;
  }
  // opacity: 0.5;
}

.work__panel__row__list__item {
  display: flex;
  flex-direction: column;
}

.work__panel__footer {
  align-items: end;
  display: grid;
  gap: var(--gutter);
  margin-top: auto;
  grid-template-columns: repeat(2, 1fr);
  opacity: 0;
  transition: 1s ease(outExpo);
  transform: translateY(2rem);

  .is-animated & {
    opacity: 1;
    transform: translateY(0rem);
  }
}

.work__panel__footer--mobile {
  margin-top: fluidMap($spacing, 120);
  margin-left: col(2);
  width: var(--col-2);
}
</style>
